import { css } from 'styled-components'

export const notifyDialogStyle = css`
	.MuiDialog-paper {
		margin: 8px;

		> .MuiBox-root {
			min-width: 240px;
			max-width: 340px;

			.header {
				position: relative;

				.MuiTypography-root {
					position: absolute;
					top: 50%;
					left: 50%;

					transform: translate(-50%, -50%);
					padding: 0 4px;
					background-color: ${({ theme }) => theme.palette.common.white};
					color: ${({ theme }) => theme.palette.primary.main};
				}
			}
		}
	}
	.content-notify {
		margin-top: 0px;
	}
	.content-notify p {
		font-size: 13px;
	}
`
